<template>
    <div
        v-if="showBanner"
        class="rounded-md bg-blue-50 p-4 dark:bg-blue-500/10 dark:outline dark:outline-1 dark:outline-blue-500/15"
    >
        <div class="flex">
            <div class="flex-shrink-0">
                <font-awesome-icon :icon="faBuilding" class="text-blue-400 dark:text-blue-300" />
            </div>
            <div class="ml-3 flex-1 md:flex md:justify-between">
                <p class="text-sm text-blue-700 dark:text-blue-100/80">
                    Your enterprise account is approved. Register your company with Experian so reports pulled by your team are requested under your company name.
                </p>
                <Link
                    :href="route('pmc-registration.create')"
                    class="whitespace-nowrap font-bold text-sm text-blue-700 hover:text-blue-600 dark:text-blue-300 dark:hover:text-blue-200"
                >
                    Register Company
                    <span aria-hidden="true"> &rarr;</span>
                </Link>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { Link, usePage } from '@inertiajs/vue3'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBuilding } from '@fortawesome/pro-solid-svg-icons'

const page = usePage()

/**
 * RAC-10417 — shown only to an approved enterprise company that has not yet
 * registered its PMC token. `needs_pmc_registration` is computed server-side in
 * HandleInertiaRequests, because approval flips the account's role from
 * enterprise to agent, so the role alone cannot identify these users.
 */
const showBanner = computed(() => Boolean(page.props.auth?.user?.needs_pmc_registration))
</script>
